import { containerNames } from '../../constants';
import { isMobile } from '../../helpers/isMobile';
import { PixiBase } from '../../core/pixi/PixiBase';
import { Spine } from '../../services/elementTypeService/Spine';
import { BitmapText } from '../../services/elementTypeService/BitmapText';

export class WinPopupDrawer {
  constructor() {
    this.animations = {};
    this.WinPopupContainer = PixiBase.createContainer(containerNames.WinPopupContainer);
    this.WinPopupContainer.visible = false;
  }

  setupWinPopup() {
    this.winPopup = new Spine({ key: 'winPopup' });
    const { x, y } = this.config.WinPopupContainer.winPopupConfig;
    PixiBase.setPosition(this.winPopup, { x: x, y: y });
    this.winPopupAmount = new BitmapText({
      fontName: 'fontWildWeenX',
      text: '',
    });
    // this.winPopup.play('epic_win_change',true)
    this.winPopupAmount.fontSize = 90;
    this.winPopupAmount.anchor.set(0.5);
    this.winPopupBackLayer = PixiBase.createGraphics();
    this.winPopupBackLayer.beginFill(0x000000);
    isMobile()
      ? this.winPopupBackLayer.drawRect(0, 0, 540, 960)
      : this.winPopupBackLayer.drawRect(0, 0, 1920, 1100);
    this.winPopupBackLayer.endFill();
    this.winPopupBackLayer.alpha = 0.4;
    this.winPopupBackLayer.visible = false;
    this.WinPopupContainer.addChild(this.winPopupBackLayer);
    this.WinPopupContainer.addChild(this.winPopup);
    this.WinPopupContainer.addChild(this.winPopupAmount);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupWinPopup();
  }
}
